import { useMemo } from "react";

type Props = {
  currentQuestion: any;
};

const ColStyle: any = {
  width: "100px",
  textAlign: "center",
  height: "35px",
  border: "1px solid black",
};

type AggregateProps = {
  currentQuestion: any;
  index: number;
  type: "row" | "column";
  aggregateType: string;
};
const AggregateField: React.FC<AggregateProps> = ({
  currentQuestion,
  index,
  type,
  aggregateType,
}) => {
  const { responses } = currentQuestion;
  const currentResponse =
    responses?.[0]?.aggregateData?.[type]?.[index]?.numberValue ?? 0;
  return (
    <>
      {aggregateType} : {currentResponse}
    </>
  );
};

const GridField = ({ currentQuestion }: Props) => {
  const { properties, responses } = currentQuestion;
  const gridConfig = properties?.gridConfig;

  const rowAggregate = useMemo(() => {
    return gridConfig?.rows?.some((row: any) => !!row.aggregateType);
  }, [gridConfig]);

  const columnAggregate = useMemo(() => {
    return gridConfig?.columns?.some((col: any) => !!col.aggregateType);
  }, [gridConfig]);

  return (
    <>
      {gridConfig?.fieldType === "row" && (
        <table style={{ maxWidth: "100%" }}>
          <thead>
            <tr>
              <td></td>
              {gridConfig?.columns.map((col: any, i: number) => (
                <td style={{ textAlign: "center" }} key={col.label + i}>
                  {col.label || "Column " + (i + 1)}
                </td>
              ))}
              {rowAggregate && (
                <td style={{ textAlign: "center" }} key="row-aggregate">
                  Aggregate
                </td>
              )}
            </tr>
          </thead>
          <tbody>
            {gridConfig?.rows.map((row: any, i: number) => (
              <tr key={row.label + i}>
                <td
                  style={{
                    minWidth: "85px",
                    textAlign: "center",
                    height: "35px",
                  }}
                >
                  {row.label || "Row " + (i + 1)}
                </td>

                {gridConfig?.columns.map((_: any, j: number) => (
                  <td key={i + j} style={ColStyle}>
                    {responses?.[0]?.gridData?.[i]?.[j]?.[
                      row?.type === "number" ? "numberValue" : "textValue"
                    ] || ""}
                  </td>
                ))}
                {rowAggregate && (
                  <td style={{ textAlign: "center" }}>
                    {row.aggregateType ? (
                      <AggregateField
                        currentQuestion={currentQuestion}
                        index={i}
                        type={"row"}
                        aggregateType={row?.aggregateType}
                      />
                    ) : (
                      "-"
                    )}
                  </td>
                )}
              </tr>
            ))}
            {columnAggregate && (
              <tr key={"col-aggregate"}>
                <td style={{ textAlign: "center" }}>Aggregate</td>

                {gridConfig?.columns.map((item: any, j: number) => (
                  <td style={{ textAlign: "center" }} key={j}>
                    {item.aggregateType ? (
                      <AggregateField
                        currentQuestion={currentQuestion}
                        index={j}
                        type={"column"}
                        aggregateType={item?.aggregateType}
                      />
                    ) : (
                      "-"
                    )}
                  </td>
                ))}

                {rowAggregate && <td></td>}
              </tr>
            )}
          </tbody>
        </table>
      )}

      {gridConfig?.fieldType === "column" && (
        <table style={{ maxWidth: "100%" }}>
          <thead>
            <tr>
              <td></td>
              {gridConfig?.columns.map((col: any, i: number) => (
                <td style={{ textAlign: "center" }} key={i}>
                  {col.label || "Column " + (i + 1)}
                </td>
              ))}
              {rowAggregate && (
                <td key={"row-aggregate"} style={{ textAlign: "center" }}>
                  Aggregate
                </td>
              )}
            </tr>
          </thead>
          <tbody>
            {gridConfig?.rows.map((row: any, i: number) => (
              <tr key={i}>
                <td
                  style={{
                    minWidth: "85px",
                    textAlign: "center",
                    height: "35px",
                  }}
                >
                  {row.label || "Row " + (i + 1)}
                </td>

                {gridConfig?.columns.map((col: any, j: number) => (
                  <td style={ColStyle} key={col.label + j}>
                    {responses?.[0]?.gridData?.[i]?.[j]?.[
                      col?.type === "number" ? "numberValue" : "textValue"
                    ] || ""}
                  </td>
                ))}
                {rowAggregate && (
                  <td style={{ textAlign: "center" }}>
                    {row.aggregateType ? (
                      <AggregateField
                        currentQuestion={currentQuestion}
                        index={i}
                        type={"row"}
                        aggregateType={row?.aggregateType}
                      />
                    ) : (
                      "-"
                    )}
                  </td>
                )}
              </tr>
            ))}
            {columnAggregate && (
              <tr key={"col-aggregate"}>
                <td style={{ textAlign: "center" }}>Aggregate</td>

                {gridConfig?.columns.map((item: any, j: number) => (
                  <td style={{ textAlign: "center" }} key={j}>
                    {item.aggregateType ? (
                      <AggregateField
                        currentQuestion={currentQuestion}
                        index={j}
                        type={"column"}
                        aggregateType={item?.aggregateType}
                      />
                    ) : (
                      "-"
                    )}
                  </td>
                ))}

                {rowAggregate && <td></td>}
              </tr>
            )}
          </tbody>
        </table>
      )}
    </>
  );
};

export default GridField;
